import accountRecoveryCopy from "./accountRecoveryCopy.json";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../utils/supabaseClient";
import { useTranslation } from "react-i18next";


const pageStyle = {
  minHeight: "calc(100vh - 220px)",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  padding: "54px 16px 80px",
  boxSizing: "border-box",
};

const cardStyle = {
  width: "100%",
  maxWidth: 430,
  background: "#f5f6fa",
  border: "1px solid #dde2ea",
  borderRadius: 20,
  boxShadow: "0 4px 16px rgba(25,32,52,0.07)",
  padding: "34px 32px 30px",
  boxSizing: "border-box",
  color: "#202534",
  fontFamily: "'Pretendard','Noto Sans KR',Arial,sans-serif",
};

const inputStyle = {
  width: "100%",
  minHeight: 48,
  padding: "0 14px",
  borderRadius: 10,
  border: "1px solid #dde2ea",
  background: "#ffffff",
  color: "#202534",
  fontSize: 18,
  outline: "none",
  boxSizing: "border-box",
};

const buttonStyle = {
  width: "100%",
  minHeight: 50,
  background: "#6650d8",
  color: "#ffffff",
  fontWeight: 900,
  border: "none",
  borderRadius: 11,
  fontSize: 19,
  padding: "11px 14px",
  boxShadow: "0 4px 16px rgba(25,32,52,0.07)",
  cursor: "pointer",
};

const labelStyle = {
  display: "block",
  marginBottom: 7,
  color: "#202534",
  fontSize: 16,
  fontWeight: 800,
};



function FindPwBox() {
  const { t, i18n } = useTranslation();
  const [userId,setUserId]=useState(""); const [successMsg,setSuccessMsg]=useState(""); const [error,setError]=useState(""); const [loading,setLoading]=useState(false);
  const lang=(i18n.language||"en").split("-")[0];

  async function handleFindPw(e) {
    e.preventDefault(); setSuccessMsg(""); setError("");
    if(!userId) { setError(t("auth.findPw.inputAll")); return; }
    setLoading(true);
    try {
      const {error:resetErr}=await supabase.auth.resetPasswordForEmail(userId.trim(),{redirectTo:`${window.location.origin}/${lang}/reset-password`});
      if(resetErr) setError(t("auth.findPw.sendFail")); else setSuccessMsg((accountRecoveryCopy[lang] || accountRecoveryCopy.en).reset);
    } catch { setError(t("auth.common.temporaryError")); }
    setLoading(false);
  }

  return <div style={pageStyle}><div style={cardStyle}>
    <div style={{textAlign:"center",marginBottom:26}}><h2 style={{margin:0,fontSize:29,fontWeight:950}}>{t("auth.findPw.title")}</h2><p style={{margin:"9px 0 0",color:"#5542b8",fontSize:16,lineHeight:1.55}}>{t("auth.findPw.subtitle")}</p></div>
    <form onSubmit={handleFindPw}>
      <label style={labelStyle}>{t("auth.common.email")}</label><input type="email" value={userId} onChange={e=>setUserId(e.target.value)} placeholder={t("auth.common.emailPlaceholder")} style={{...inputStyle,marginBottom:16}} maxLength={50} disabled={loading} autoComplete="username" />
      <button type="submit" style={{...buttonStyle,opacity:loading?.65:1}} disabled={loading}>{loading?t("auth.findPw.loading"):t("auth.findPw.submit")}</button>
    </form>
    {successMsg&&<div style={{color:"#167044",marginTop:16,textAlign:"center",fontWeight:800,lineHeight:1.5}}>{successMsg}</div>}
    {error&&<div style={{color:"#b42346",marginTop:16,textAlign:"center",fontWeight:700}}>{error}</div>}
    <div style={{marginTop:22,paddingTop:18,borderTop:"1px solid #dde2ea",textAlign:"center"}}><Link to={`/${lang}/login`} style={{color:"#5542b8",fontWeight:900,textDecoration:"none"}}>← {t("auth.common.backToLogin")}</Link></div>
  </div></div>;
}
export default FindPwBox;
